import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  html, body {
    background: ${props => props.theme.colors.red};
    max-width: 100%;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.25s ease-out;
  }

  button {
    background: none;
    border: 0;
    outline: none;
  }
`;

export default GlobalStyles;
